import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ColorSkinWrapper = ({ children, bookmakerName, className }) => (
    <div
        className={classNames(
            className,
            { [`bs-skin_${bookmakerName}`]: bookmakerName },
        )}
    >
        {children}
    </div>
);

ColorSkinWrapper.defaultProps = {
    bookmakerName: '',
    children: null,
    className: '',
};

ColorSkinWrapper.propTypes = {
    bookmakerName: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    className: PropTypes.string,
};

export default ColorSkinWrapper;



// WEBPACK FOOTER //
// /src/js/common/colorSkinWrapper/ColorSkinWrapper.jsx